// @flow

import * as React from "react";
import { Link } from "react-router-dom";
import ReactGA from "react-ga";

import type { WorkProgress } from "../../utils/progress";
import { progressMessage } from "../../utils/progress";

import "./QuestionHeader.css";

type Props = {
  progress: WorkProgress,
  unsetHeader: () => void
};

const QuestionHeader = (props: Props) => (
  <div className="QuestionHeader">
    <span>{progressMessage(props.progress)}</span>
    <div className="QuestionHeader-Exit">
      <Link
        to="/"
        onClick={(e: Event) => {
          ReactGA.event({ category: "Task", action: "Top Exit" });
          props.unsetHeader();
        }}
      >
        x
      </Link>
    </div>
  </div>
);

export default QuestionHeader;



// WEBPACK FOOTER //
// ./src/components/QuestionHeader/QuestionHeader.js